import blogData from './blog-posts.json';
import type { BlogPost, BlogPostMeta, BlogCategory } from '../types/blog';


const posts: BlogPost[] = blogData.posts as BlogPost[];
const categories: BlogCategory[] = blogData.categories as BlogCategory[];

export function getAllPosts(): BlogPostMeta[] {
  return posts.map(({ html: _html, ...meta }) => meta);
}

export function getPostBySlug(slug: string): BlogPost | undefined {
  return posts.find(p => p.slug === slug);
}

export function getPostsByCategory(categoryId: string): BlogPostMeta[] {
  return getAllPosts().filter(p => p.category === categoryId);
}

export function getAllCategories(): BlogCategory[] {
  return categories;
}

export function getCategoryById(id: string): BlogCategory | undefined {
  return categories.find(c => c.id === id);
}

export function getAdjacentPosts(slug: string): { prev: BlogPostMeta | null; next: BlogPostMeta | null } {
  const all = getAllPosts(); // sorted newest-first
  const index = all.findIndex(p => p.slug === slug);
  if (index === -1) return { prev: null, next: null };
  // "prev" = older post = higher index in newest-first array
  // "next" = newer post = lower index in newest-first array
  const prev = index < all.length - 1 ? (all[index + 1] ?? null) : null;
  const next = index > 0 ? (all[index - 1] ?? null) : null;
  return { prev, next };
}

export function getRelatedPosts(slug: string, limit = 3): BlogPostMeta[] {
  const all = getAllPosts();
  const current = all.find(p => p.slug === slug);
  if (!current) return [];
  return all
    .filter(p => p.slug !== slug && p.category === current.category)
    .slice(0, limit);
}
